"use client";
import dynamic from "next/dynamic";

const LiveLecture1CSR = dynamic(
  () => import("./index"),
  {
    ssr: false,
  },
);

export default LiveLecture1CSR;
